module.exports = __webpack_public_path__ + "img/commercialisti-emt.426beb51.png";